import { useEffect, useState } from 'react';
import { currentUser, onLoginStateChanged } from './auth/auth';

export function useUser() {
    const [user, setUser] = useState(currentUser());
    useEffect(() => onLoginStateChanged.on(() => setUser(currentUser())), []);
    return user;
}
